import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ModalBasicComponent } from '../../../../shared/modal-basic/modal-basic.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NotasFiscaisService } from '../../../../services/notas-fiscais.service';
import { MessageService } from '../../../../services/message.service';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { getDeviceType, markFormGroupTouched } from '../../../../general/utils';
import { ModalCadastroComponent } from '../../../../shared/modal-cadastro/modal-cadastro.component';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-saidas-por-estado',
  templateUrl: './saidas-por-estado.component.html',
  styleUrls: ['./saidas-por-estado.component.css']
})
export class SaidasPorEstadoComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('modalRelatorio', { static: true }) modalRelatorio: ModalBasicComponent;
  @Output() closed: EventEmitter<any> = new EventEmitter();
  impressaoForm: FormGroup;
  loading = false;
  constructor(private nfService: NotasFiscaisService, private message: MessageService) { super(); }

  ngOnInit() {
    this.impressaoForm = new FormGroup({
      dataInicio: new FormControl(moment().startOf('month').toDate(), [Validators.required]),
      dataFim: new FormControl(moment().endOf('month').startOf('day').toDate(), [Validators.required]),
      orientacao: new FormControl('vertical')
    });
  }

  destroyComponent() {
    this.closed.emit();
  }

  validaForm() {
    markFormGroupTouched(this.impressaoForm);
  }

  show(): void {
    this.modalRelatorio.show();
  }

  submitForm() {
    if (this.impressaoForm.valid) {
      this.loading = true;
      this.modalRelatorio.hide();
      this.nfService.saidasPorEstado(this.impressaoForm.value)
        .pipe(finalize(() => this.loading = false))
        .subscribe(res => {
          saveAs(res, 'SaidasPorEstado.pdf');
          this.destroyComponent();
        }, (error) => {
          this.message.addError({
            title: 'Falha ao gerar relatório',
            msg: error.errors[0],
            showClose: true, timeout: 20000, theme: 'bootstrap', closeOther: true
          });

          this.destroyComponent();
        });
    }
  }
}
